var map = {
	"./armsOfRealize.png": 647,
	"./faithfulWill.png": 6494,
	"./legsOfFreedom.png": 9310,
	"./lightPerception.png": 4522,
	"./magicTail.png": 132,
	"./mysticEyes.png": 9830,
	"./twistOfFate.png": 5235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5372;